import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { Auth0Service } from '../auth0/auth0.service'
import { Observable, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
/**
* This interceptor is used to bind the token to each API after successful login.
*/
@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(public auth0: Auth0Service) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = this.addTokenToHeader(request);
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          return this.handle401Error(request, next);
        }
        return throwError(error);
      }))
  }

  private handle401Error(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<any> {
    return this.auth0
      .renewTokens()
      .pipe(
        switchMap((jwt: any) => {
          return next
            .handle(this.addTokenToHeader(request))
            .pipe(
              map((event: HttpEvent<any>) => {
                return this.eventCallSendBack(event);
              })
            );
        }),
        catchError(err => {
          return throwError(err);
        })
      );

  }

  private eventCallSendBack(event) {
    if (event instanceof HttpResponse) {
      return event.clone({ body: event.body });
    }
    return event;
  }

  addTokenToHeader(request: HttpRequest<any>) {
    if (this.auth0.accessToken) {
      return request.clone({
        setHeaders: {
          Authorization: `${this.auth0.tokenType} ${this.auth0.accessToken}`
        }
      })
    }
    return request;
  }
}
